import { ReduxState } from "Store/rootReducer";
import { Partner } from "./partnerInterfaces";

export const partnerIdSelector = (state: ReduxState): Partner | "" =>
  state.partner.partnerId;
